import './dragdrop.webview2.polyfill.js'
import React, { PureComponent, createRef } from 'react'
import ReactDOM from 'react-dom'
import { Alert, notification, Button } from 'antd';
import { SettingOutlined } from '@ant-design/icons';
import { Menu, ContextMenu } from '@antv/x6-react-components'
import html2canvas from 'html2canvas'
import $ from 'jquery'
// import { message } from 'antd';

import NetworkGraph from './Graph/index.ts'
import ToolBar from './components/ToolBar'
import SetncilBar from './components/StencilBar'
import './index.css'
import { GraphNetworkSimulatorBridge } from './components/Device/Bridge'
import DeviceModal from './components/DeviceModal'
import DeviceUIConfigModal from './components/DeviceUIConfigModal'

import '@antv/x6-react-components/es/menu/style/index.css'
import '@antv/x6-react-components/es/context-menu/style/index.css'

class NetworkSimulator extends PureComponent {

  constructor({ singleton = false }) {
    super();

    // 启动时创建两个引用，用于引用DOM节点
    this.containerRef = createRef();

    // 是否单机模式
    this.singleton = singleton;

    // 绑定函数this
    ['onChange', 'onResize', 'onRecvMessage', 'postMessage', 'onDoubleClickDevice', 'onCloseModal', 'onDropIcon', 'onDropOver', 'onNodeContextMenu', 'onRemoveNode', 'onShowProperties'].forEach(func => {
      this[func] = this[func].bind(this);
    });

    this.state = {
      // 当前配置中的设备
      currentNode: null,
      currentDevice: null,
      contextMenuInfo: null,
      readOnly: false,
      isAdmin: new URLSearchParams(window.location.search).get('admin') === '1',
      uiConfig: null,
      showUIConfigModal: false,
    };

    this.contextMenus = (
      <Menu>
        <Menu.Item onClick={this.onShowProperties} key="properties">属性</Menu.Item>
        <Menu.Item onClick={this.onRemoveNode} key="delete">删除</Menu.Item>
      </Menu>
    );
  }

  componentDidMount() {
    const { singleton } = this;

    // DOM加载完毕时，初始化图形和桥接器
    const { containerRef } = this;
    const containerDom = containerRef.current;

    this.graph = NetworkGraph.init(containerDom);
    this.graphNetworkSimluatorBridge = new GraphNetworkSimulatorBridge(this.graph, this.onChange);
    this.setState({ uiConfig: this.graphNetworkSimluatorBridge.getUIConfig() });

    // 双击节点
    this.graph.on("node:dblclick", this.onDoubleClickDevice);

    // 监听画布右键菜单
    this.graph.on('blank:contextmenu', this.onNodeContextMenu);

    // 右击节点
    this.graph.on("node:contextmenu", this.onNodeContextMenu);

    // 响应尺寸变化
    window.addEventListener('resize', this.onResize);
    this.onResize();

    // 单机模式
    if(singleton) {
      // 加载localStorage数据
      if(localStorage.networkSimulator) {
        let storagedValue = JSON.parse(localStorage.networkSimulator);
        this.graphNetworkSimluatorBridge.fromJSON(storagedValue);
        this.setState({ uiConfig: this.graphNetworkSimluatorBridge.getUIConfig() });
      }
    }
    else {
      // 监听主应用传递消息
      window.addEventListener("message", this.onRecvMessage);
    }

    const that = this;
    setTimeout(() => {
      try {
        html2canvas(containerDom, {
          allowTaint: false,
          useCORS: true,
          // foreignObjectRendering : true,
          // allowTaint :false,
          // taintTest: true,
          // scale: 1,
          // dpi: 150,
          // width: $(containerDom).width(),
          // height: $(containerDom).height(),
          // useCORS: true,//保证跨域图片的显示，如果为不添加改属性，或者值为false,地图底图不显示
        }).then((canvas) => {
          const src = canvas.toDataURL();
          that.postMessage({ type: 'loadRef', function: 'componentDidMount', src, width: $(containerDom).width(), height: $(containerDom).height() })
        })
      } catch(e) {
        console.log(e)
        that.postMessage({ type: 'error', function: 'componentDidMount', e })
      }
    }, 1000)

    // 监听页面退出，给出提示建议保存后再退出
    // window.onbeforeunload = function(event){
    //   return '您可能有数据没有保存';
    // };
  }

  componentWillUnmount() {
    const { singleton, graphNetworkSimluatorBridge, graph } = this;

    graph.off("node:dblclick", this.onDoubleClickDevice);
    graph.off('blank:contextmenu', this.onNodeContextMenu);
    graph.off("node:contextmenu", this.onNodeContextMenu);

    // 解除尺寸变化
    window.removeEventListener('resize', this.onResize);

    // 单机模式 / 组件模式
    if(singleton) {

    }
    else {
      // 解除监听主应用传递消息
      window.removeEventListener("message", this.onRecvMessage);
    }

    // 解除桥接
    graphNetworkSimluatorBridge.destory();
  }

  // 当右键触发时
  onNodeContextMenu(args) {
    const {
      e: { clientX, clientY },
      node,
    } = args;

    const { graph } = this;

    // 如果是禁止移动的节点，也不支持右键菜单
    let disableMove = false;

    if(node) {
      const data = node.getData();
      disableMove = data && data.disableMove;
    }

    if(!node || disableMove) {
      graph.cleanSelection();

      this.setState({
        contextMenuInfo: null
      });

      return;
    }


    // NOTE: if the clicked node is not in the selected nodes, then clear selection

    if (!graph.getSelectedCells().includes(node)) {
      graph.cleanSelection();
      graph.select(node);
    }

    this.setState({
      contextMenuInfo: {
        x: clientX,
        y: clientY,
        node
      }
    });
  }

  // 当点击删除按钮时
  onRemoveNode() {
    const { contextMenuInfo } = this.state;
    const { graph, graphNetworkSimluatorBridge } = this;
    const { node } = contextMenuInfo;

    if (!graph) {
      return;
    }

    // 若已有多选，则批量删除多选节点；否则删除当前节点
    let targetNodes = graph.getSelectedCells().filter((cell) => cell && cell.isNode && cell.isNode());
    if (!targetNodes.length) {
      targetNodes = [node];
    }

    // 先销毁对应设备，防止残留链路
    targetNodes.forEach((n) => {
      const device = graphNetworkSimluatorBridge.getDeviceByNode(n);
      if (device) {
        device.destory();
      }
    });

    // 删除节点（关联的边由 x6 自动移除）
    graph.removeCells(targetNodes);

    this.setState({
      currentNode: null,
      currentDevice: null,
      contextMenuInfo: null,
    });
  }

  // 当点击按钮时
  onShowProperties() {
    const { contextMenuInfo } = this.state;
    const { node } = contextMenuInfo;

    // 获取对应设备对象
    const device = this.graphNetworkSimluatorBridge.getDeviceByNode(node);

    // 根据设备对象类型加载模态框
    this.setState({
      currentNode: node,
      currentDevice: device,
      contextMenuInfo: null,
    });
  }

  // 接收主应用消息
  onRecvMessage(event) {
    // 单独调试微应用，不需要监听自己发送的消息
    if(window === event.source) {
      return;
    }

    if(window.parent !== event.source){
      return
    }

    console.debug('收到主应用数据', event.data);
    // message.info('收到主应用数据' + JSON.stringify(event.data), 100);
    const { instanceID, mode, props } = event.data;

    // 记录事件来源，实例ID
    this.mainOrigin = event.data.origin;
    this.instanceID = instanceID;

    // 设置只读模式
    if(mode === 'preview') {
      this.setState({
        readOnly: true
      }, () => {
        this.onResize();
      });
    }

    // 加载图形数据

    // 新建，无需加载
    if(!props) {
      return;
    }

    // debugger;
    try {
      this.graphNetworkSimluatorBridge.fromJSON(props);
      this.setState({ uiConfig: this.graphNetworkSimluatorBridge.getUIConfig() });
    }
    catch(e) {
      notification.error({
        message: '加载网络模拟器数据时出错！',
        description: '请提供网址和账号给研发人员进行调试！'
      });
      console.error('加载网络模拟器数据时出错！请提供网址和账号给研发人员进行调试！');
      console.log(props);
      console.error(e);
    }
  }

  // 每次onChange向主应用传递消息
  postMessage(networkValue) {
    const { mainOrigin, instanceID } = this;
    // debugger;
    // message.info('向主应用发送数据' + JSON.stringify({props: networkValue, instanceID}), 100);
    window.parent.postMessage({props: networkValue, instanceID}, mainOrigin);
  }

  // 当双击设备
  onDoubleClickDevice({node}) {
    // 如果是指示灯，那么不处理
    if (node.shape === "IndicatorLight") {
      return;
    }

    // 获取对应设备对象
    const device = this.graphNetworkSimluatorBridge.getDeviceByNode(node);

    if(!device) {
      notification.error({
        message:'无法找到对应的设备数据！',
        description: '请尝试回忆最近可能导致问题的操作并告知研发人员，帮助定位错误',
      });

      return;
    }

    // 根据设备对象类型加载模态框
    this.setState({
      currentNode: node,
      currentDevice: device
    });
  }

  // 关闭窗口
  onCloseModal() {
    this.setState({
      currentNode: null,
      currentDevice: null
    });
  }

  // 当发生任何修改，都存储网络图
  onChange() {
    // 只读模式不存储
    const { readOnly, containerRef } = this;
    const containerDom = containerRef.current;
    if(readOnly) {
      return;
    }

    const { graphNetworkSimluatorBridge, singleton } = this;
    const json = graphNetworkSimluatorBridge.toJSON();

    // 单机模式存入localStorage，组件化递送到主应用
    if (singleton) {
      // console.log(json);
      localStorage.networkSimulator = JSON.stringify(json);
    }
    else {
      this.postMessage(json);
    }

    try {
      html2canvas(containerDom, {
        allowTaint: false,
        useCORS: true,
        // foreignObjectRendering : true,
        // allowTaint :false,
        // taintTest: true,
        // scale: 1,
        // dpi: 150,
        // width: $(containerDom).width(),
        // height: $(containerDom).height(),
        // useCORS: true,//保证跨域图片的显示，如果为不添加改属性，或者值为false,地图底图不显示
      }).then((canvas) => {
        const src = canvas.toDataURL();
        this.postMessage({ type: 'loadRef', function: 'onChange', src, width: $(containerDom).width(), height: $(containerDom).height() })
      })
    } catch(e) {
      console.log(e)
      this.postMessage({ type: 'error', function: 'onChange', e })
    }
  }

  // 在放置图标时
  onDropIcon(e) {
    const { graph, graphNetworkSimluatorBridge } = this;
    // 释放时增加节点，优先使用 dragstart 写入的全局值，兼容 dataTransfer
    const globalType = (typeof window !== 'undefined' && window.__hxrCurrentDragDevice) ? window.__hxrCurrentDragDevice : '';
    const appType = e.dataTransfer.getData("application/x-device");
    const textPlainType = e.dataTransfer.getData("text/plain");
    const textType = e.dataTransfer.getData("text");
    // 优先使用 dragstart 写入的全局值（可靠），再兼容 dataTransfer
    const typeName = globalType || appType || textPlainType || textType;
    console.debug('[drag-drop] typeName', { appType, textPlainType, textType, globalType, final: typeName });
    if(!graph) {
      return;
    }
    if(!typeName) {
      return;
    }

    graphNetworkSimluatorBridge.addGraphNode(typeName, e.clientX, e.clientY);

    if (e.dataTransfer && e.dataTransfer.clearData) {
      e.dataTransfer.clearData();
    }
    if (typeof window !== 'undefined' && window.__hxrCurrentDragDevice) {
      delete window.__hxrCurrentDragDevice;
    }
  }

  // 在放置结束时
  onDropOver(e) {
    e.preventDefault();
  }

  // 监听屏幕变化
  onResize() {
    const { graph } = this;
    const { readOnly } = this.state;

    // 减去工具栏款
    const width = document.body.offsetWidth - (readOnly ? 0: 130);
    const height = document.body.offsetHeight;
    graph.resize(width, height);
  }

  render() {
    const { containerRef, contextMenus } = this;
    const { currentNode, currentDevice, contextMenuInfo, readOnly, isAdmin, uiConfig, showUIConfigModal } = this.state;

    // 调整了布局，使得界面始终全屏幕
    return (
      <ContextMenu {...contextMenuInfo} visible={contextMenuInfo} menu={contextMenus} >
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            width: '100%',
            height: '100vh'
          }}
        >
          <style>
              {/* 设置滚动条为圆角 */}
              {`
                  ::-webkit-scrollbar {
                      width: 10px;
                      height: 10px;
                  }
                  ::-webkit-scrollbar-thumb {
                      border-radius: 10px;
                      background: rgba(0, 0, 0, 0.2);
                  }
                  ::-webkit-scrollbar-track {
                      border-radius: 10px;
                      background: rgba(255, 255, 255, 0.2);
                  }
                  ::-webkit-scrollbar-button {
                      width: 0;
                      height: 0;
                  }

                  .x6-menu-item-button {
                    width: 90%;
                  }
              `}
          </style>
          { isAdmin ? <DeviceUIConfigModal
              visible={showUIConfigModal}
              uiConfig={uiConfig || GraphNetworkSimulatorBridge.getDefaultUIConfig()}
              onClose={() => this.setState({ showUIConfigModal: false })}
              onSave={(config) => {
                this.graphNetworkSimluatorBridge.setUIConfig(config);
                this.setState({ uiConfig: this.graphNetworkSimluatorBridge.getUIConfig(), showUIConfigModal: false });
              }}
            /> : null }
          { currentDevice ? <DeviceModal node={currentNode} device={currentDevice} isAdmin={isAdmin} onClose={this.onCloseModal} /> : null }
          {/* 只读模式不放设备 */}
          { readOnly ? null: <SetncilBar uiConfig={uiConfig || GraphNetworkSimulatorBridge.getDefaultUIConfig()} /> }
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              flex: 1,
              borderRight: '1px solid rgba(0, 0, 0, 0.08)',
            }}
          >
            {/* 只读模式不放设备 */}
            {readOnly ? <Alert style={{ width: '100%', userSelect: 'none' }} message="只读模式，可用于检查和验证，无法新建设备，修改也不会被保存" type="warning" />: null }
            {
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  paddingRight: 12,
                  paddingLeft: 12,
                  height: '38px',
                  backgroundColor: '#f7f9fb',
                  borderBottom: '1px solid rgba(0, 0, 0, 0.08)',
                  gap: 8,
                }}
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                  {isAdmin ? (
                    <div style={{ display: 'flex', alignItems: 'center', paddingRight: 6, borderRight: '1px solid rgba(0,0,0,0.08)' }}>
                      <Button
                        size="small"
                        type="text"
                        icon={<SettingOutlined />}
                        title="界面配置"
                        onClick={() => this.setState({ showUIConfigModal: true })}
                      />
                    </div>
                  ) : null}
                  <ToolBar />
                </div>
                <a style={{ color: '#888', paddingLeft: 10, lineHeight: "28px" }} title="了解更多氦星人产品" href="https://hxr.iyopu.com" target='_blank' rel="noopener noreferrer">氦星人™&nbsp;荣誉出品</a>
              </div>
            }
            <div
              onDrop={this.onDropIcon} onDragOver={this.onDropOver} onClick={() => {
                if(contextMenuInfo) {
                  this.setState({
                    contextMenuInfo: null
                  });
                }

              }}
              ref={containerRef} className="x6-graph" style={{ height: '100%', width: '100%', position: 'relative'}}
            />
          </div>
        </div>
      </ContextMenu>
    );
  }
}

// 启动应用
const container = document.getElementById("microNetworkSimulator");

// 独立启动应用时不会有参数microApp=1
ReactDOM.render(<NetworkSimulator singleton={window.location.search.indexOf('microApp=1') === -1} />, container);

